<template>
  <div
    v-if="mapReady"
    class="map-container"
  >
    <GmapMap
      ref="mapRef"
      :center="mapCenter"
      :zoom="6"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      @tilesloaded="addCustomControl"
    >
      <template>
        <gmap-custom-marker
          v-for="(mrk, i) in jobMarkers"
          :key="i"
          :marker="mrk"
        >
          <span>
            <v-icon
              v-if="i === 0"
              color="#000"
              x-large
            >
              mdi-google-maps
            </v-icon>
            <Icons
              v-else-if="i == jobMarkers.length - 1"
              name="marker-end"
            />
            <Icons
              v-else
              :name="`marker-${i}`"
            />
          </span>
        </gmap-custom-marker>
      </template>

      <GmapPolyline
        :path="routeCoordinates"
        :options="lineOptions"
      />
      <GmapPolyline
        :path="followRoute"
        :options="followLineOptions"
      />
    </GmapMap>

    <div
      ref="customControl"
      class="custom-map-control"
    >
      <div>
        <v-card class="map-job-content">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>
              <div class="d-flex -justify-space-between align-center">
                <div>
                  <v-btn
                    color="dark"
                    text
                    x-small
                    @click="redirect()"
                  >
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                </div>
                <div class="mx-1">
                  Job Activity
                </div>
              </div>
              <div class="title">
                {{ vehcileName }}
              </div>
            </div>
            <div
              class="open-link"
              @click="() => (isOpen = !isOpen)"
            >
              <v-icon>mdi-menu</v-icon>
            </div>
          </v-card-title>
          <v-card-text v-if="isOpen">
            <div
              v-for="(r, i) in jobs"
              :key="i"
              class="tag"
            >
              <div class="d-flex justify-space-between align-center">
                <div class="content-info">
                  <div>
                    {{ r.location_name }}
                  </div>
                  <div class="text-muted">
                    <span v-if="r.status == 'progress'">
                      {{ r.started_at | formatDate }}
                    </span>
                    <span v-else-if="r.status == 'completed'">
                      {{ r.completed_at | formatDate }}
                    </span>
                  </div>
                </div>
                <div
                  class="status"
                  :class="r.status"
                >
                  <v-icon>
                    {{
                      r.status == "completed" ? "mdi-check-all" : "mdi-circle"
                    }}
                  </v-icon>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GmapCustomMarker from "vue2-gmap-custom-marker";

// import Vue from "vue";
// import myBox from "./utils/myBox.vue";

export default {
  name: "GoogleJobRoute",
  components: {
    GmapCustomMarker,
    Icons: () => import("@/components/base/icons.vue"),
  },
  data() {
    return {
      mapReady: false,
      mapCenter: { lat: 30.3753, lng: 69.3451 },
      isOpen: true,

      lineOptions: {
        // Added line options
        strokeColor: "#4287f5", // Line color
        strokeOpacity: 1.0,
        strokeWeight: 4,
      },
      followLineOptions: {
        // Added line options
        strokeColor: "#f2821f", // Line color
        strokeOpacity: 1.0,
        strokeWeight: 4,
      },
    };
  },
  computed: {
    ...mapGetters({
      loading: "routePlaning/getLoading",
      jobRoutes: "routePlaning/getJobRoutes",
    }),
    vehcileName() {
      if (this.jobRoutes?.jobs?.length > 0) {
        return this.jobRoutes?.jobs[0]?.vehicle_name;
      }
      return "";
      //   return this.jobRoutes?.jobs[0]?.vehicle_name;
    },

    jobs() {
      const arr = [];
      if (this.jobRoutes?.jobs) {
        this.jobRoutes.jobs.forEach((el) => {
          el.route = el.route.coordinates.map((r) => r.reverse());
          arr.push(el);
        });
      }
      return arr;
    },
    jobMarkers() {
      const arr = [];
      if (this.jobs.length > 0) {
        const data = [...this.jobs];
        data.forEach((el, i) => {
          const r = el.route[0];
          arr.push({ lat: r[0], lng: r[1] });
          if (!data[i + 1]) {
            const len = el.route.length;
            const r = el.route[len - 1];
            arr.push({ lat: r[0], lng: r[1] });
          }
        });
      }
      return arr;
    },
    routeCoordinates() {
      const arr = [];
      if (this.jobs.length > 0) {
        const rt = [...this.jobs];
        rt.forEach((r) => {
          r?.route.forEach((el) => {
            arr.push({ lat: el[0], lng: el[1] });
          });
        });
      }
      return arr;
    },
    followRoute() {
      return this.jobRoutes?.followed_route || [];
    },
    // path() {
    //   const arr = this.jobRoutes?.jobs.map(r=> );
    //   return [];
    // },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    addCustomControl() {
      setTimeout(() => {
        const map = this.$refs?.mapRef?.$mapObject;
        const controlDiv = this.$refs?.customControl;
        // // Only add if not already added
        if (!this._customControlAdded) {
          map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(
            controlDiv
          );
          this._customControlAdded = true;
        }
      }, 500);
    },
    async fetchData() {
      const params = {
        date: this.$route?.query.date,
        vehicle_id: this.$route?.params?.id,
      };
      await this.$store.dispatch("routePlaning/jobRoutes", params);
      this.$nextTick(() => {
        this.mapReady = true; // <-- SET TO TRUE AFTER DATA IS READY
        this.setMapBounds(); // Call this here, after map is ready
      });
    },
    setMapBounds() {
      setTimeout(() => {
        this.$refs.mapRef.$mapPromise.then((map) => {
          // map is loaded now set  map bound
          const arr = this.routeCoordinates;
          if (!arr.length) return;
          const bounds = new window.google.maps.LatLngBounds();
          arr.forEach((v) => {
            bounds.extend(new window.google.maps.LatLng(v.lat, v.lng));
          });
          map.fitBounds(bounds);
          // setTimeout(() => {
          //   // let currentZoom = map.getZoom();
          //   // map.setZoom(currentZoom - 1); // Zoom out slightly
          // }, 500);
        });
      }, 300);
    },
    redirect() {
      return this.$router.push({ name: "route_planning" });
    },
  },
};
</script>
<style lang="sass" scoped>
.map-container
  position: absolute
  width: 100%
  height: 100%
  top: 0
  left: 0
.map-job-content
    width: 250px

    .v-card__title
        outline:  1px solid lightgrey


    .v-card__text
        // padding-top: 1rem
        height: 65vh
        overflow-y: auto
        padding: 0
        .tag
            border-top: 1px solid lightgrey
            padding: 0.8em 0.5rem

            .content-info
                font-size: 12px


            .status
                i
                    font-size: 14px

            // status color
            .pending
                i
                    color: #f3ef35
            .progress
                i
                    color: #20a390
            .completed
                i
                    color: #1867c0
            // status color

.text-muted
    color: grey
    font-size: 11px

.custom-map-control
  position: absolute !important
  left: 0.7rem !important
  top: 4rem !important
</style>
